import React, {Component} from "react"
import "./components/custom/custom_style.css"
import {withRouter} from "react-router-dom"
import LoginForm from "./containers/LoginForm"

class Login extends Component{
    constructor(props){
        super(props)
        console.log("Hello Login")
    }
    render(){
        return <div className="c_container">
                <LoginForm/>
            </div>
    }
}

export default withRouter(Login)